import { DevProcessContent, IsDarkModeProp } from "../common/types";
import { IdeaIcon, CodeIcon, OrigamiIcon } from "../ui/BoldTextComponents";
import React from "react";
import { styled } from "styled-components";

export const DevContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  align-items: center;
  gap: 20px;
`;

const DevCard = styled.div`
  width: 280px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: 1px solid ${({ theme }) => theme.circularIconBg};
  border-radius: 10px;
  padding: 20px;
  flex-direction: column;
  height: 300px; /* Fixed height for uniformity */

  @media (max-width: 319px) {
    width: 100%;
  }
`;

const processContent: DevProcessContent[] = [
  {
    title: "Refining Ideas",
    msg: "I turn business needs into structured logic and clear backend workflows that drive real functionality.",
    icon: "idea",
  },
  {
    title: "Designing",
    msg: "Once the logic is clear, I focus on designing scalable APIs and data flows that ensure performance and reliability",
    icon: "design",
  },
  {
    title: "Building",
    msg: "From there, I bring the backend to life—secure, maintainable, and ready to support real user needs.",
    icon: "build",
  },
];

const getIcon = (icon: string, isDarkMode: boolean) => {
  switch (icon) {
    case "idea":
      return <IdeaIcon isDarkMode={isDarkMode} />;
    case "design":
      return <OrigamiIcon isDarkMode={isDarkMode} />;
    case "build":
      return <CodeIcon isDarkMode={isDarkMode} />;
    default:
      return null;
  }
};

const DevProcess: React.FC<IsDarkModeProp> = ({ isDarkMode }) => {
  return (
    <DevContainer className="App-margin">
      {processContent.map((item, index) => (
        <DevCard key={index}>
          <span>{item.title}</span>
          <p
            style={{ fontWeight: "200", overflowY: "auto" }}
            className="text-center"
          >
            {item.msg}
          </p>
          {getIcon(item.icon, isDarkMode)}
        </DevCard>
      ))}
    </DevContainer>
  );
};

export default React.memo(DevProcess);
